import { FC } from 'react'

import { ContentUnavailable } from '@/components/ContentUnavailable/ContentUnavailable'
import { MatchCommentaryContent } from '@/components/DataWidget/components/MatchCommentaryContent'
import { MatchPageProps } from '@/components/DataWidget/types'
import { Arrow, orientation } from '@/constants/focus'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'

import { Match } from './Match'
import { commentaryScrollOffset } from '../constants'
import {
  CommentaryWrapper,
  ContentUnavailableWrapper,
  MatchesContainer,
  MatchesHorizontalScrollContainer,
  MatchWrapper,
} from '../styles'

export const MatchPage: FC<MatchPageProps> = ({ match, commentaryType }) => {
  const { t } = useCommonTranslation()

  const renderMatch = () => {
    if (!match) {
      return (
        <ContentUnavailableWrapper>
          <ContentUnavailable>
            {t('dataWidget.commentary.noData')}
          </ContentUnavailable>
        </ContentUnavailableWrapper>
      )
    }

    return (
      <MatchesHorizontalScrollContainer disabled>
        <MatchWrapper data-active="true">
          <Match match={match} isCommentaryTab />
        </MatchWrapper>
      </MatchesHorizontalScrollContainer>
    )
  }

  const onArrowHandler = (e: LRUDEvent) => {
    const container = e.targetNode.elRef.current
    if (e.key === Arrow.DOWN) {
      return container?.scrollTo(
        0,
        container.scrollTop + commentaryScrollOffset,
      )
    }
    if (e.key === Arrow.UP) {
      if (container && container.scrollTop > 0) {
        e.preventDefault()
        e.stopPropagation()
        container.scrollTo(0, container.scrollTop - commentaryScrollOffset)
      }
      return
    }
  }

  const matches = match ? [match] : []

  return (
    <CommentaryWrapper orientation={orientation.VERTICAL}>
      <MatchesContainer>{renderMatch()}</MatchesContainer>
      <MatchCommentaryContent
        matches={matches}
        activeMatch={match}
        onArrowHandler={onArrowHandler}
        commentaryType={commentaryType}
      />
    </CommentaryWrapper>
  )
}
